// Typed-answer matching for desktop keyboard play — pure & tested like
// speed.ts/press.ts. The player types the VALUE of a card (the mathy way, not
// "press 3 for the third card"); this decides when the buffer picks a card.
//
//   commit  — the buffer IS an option and no other option starts with it
//   pending — the buffer could still grow into an option; if it's already an
//             exact match (`exact`), the caller commits it after a short wait
//   none    — no option starts with the buffer (caller clears, no penalty)

export type TypedMatch =
  | { kind: "commit"; value: number }
  | { kind: "pending"; exact?: number }
  | { kind: "none" };

export function typedMatch(buffer: string, options: number[]): TypedMatch {
  if (!buffer) return { kind: "none" };
  let exact: number | undefined;
  let extendable = false;
  for (const o of options) {
    const s = String(o);
    if (s === buffer) exact = o;
    else if (s.startsWith(buffer)) extendable = true;
  }
  if (exact !== undefined && !extendable) return { kind: "commit", value: exact };
  if (exact !== undefined) return { kind: "pending", exact };
  if (extendable) return { kind: "pending" };
  return { kind: "none" };
}
